import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CircleNotch, Database } from "@phosphor-icons/react";

const STAGES = [
  "Menghubungkan ke Google Sheets…",
  "Memuat data penjualan…",
  "Menyusun KPI & grafik…",
  "Hampir selesai…",
];

export default function DashboardLoading() {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setStage(1), 2500),
      setTimeout(() => setStage(2), 6000),
      setTimeout(() => setStage(3), 10000),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="p-6" data-testid="dashboard-loading">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        className="max-w-md mx-auto mt-16 rounded-2xl bg-card p-8 shadow-sm ring-1 ring-black/[0.03] text-center">
        <div className="relative w-14 h-14 mx-auto mb-5">
          <span className="absolute inset-0 rounded-2xl" style={{ background: "#EAF5EC" }} />
          <span className="absolute inset-0 flex items-center justify-center">
            <Database size={24} weight="fill" className="text-primary" />
          </span>
          <CircleNotch size={56} weight="bold" className="text-primary/60 animate-spin absolute inset-0" />
        </div>

        <h2 className="font-display font-extrabold text-lg tracking-tight" data-testid="dashboard-loading-title">
          Menyiapkan data…
        </h2>
        <motion.p key={stage} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }}
          className="text-sm text-muted-foreground mt-1.5" data-testid="dashboard-loading-stage">
          {STAGES[stage]}
        </motion.p>
        <p className="text-xs text-muted-foreground/80 mt-3 leading-relaxed">
          Pemuatan pertama mengambil data dari Google Sheet dan bisa memakan beberapa detik.
          Mohon tunggu sebentar.
        </p>

        <div className="mt-5 h-1.5 rounded-full bg-secondary overflow-hidden">
          <motion.div className="h-full rounded-full bg-primary"
            initial={{ x: "-60%" }} animate={{ x: "160%" }}
            transition={{ repeat: Infinity, duration: 1.4, ease: "easeInOut" }}
            style={{ width: "40%" }} />
        </div>
      </motion.div>
    </div>
  );
}
